var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkarrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25.5,
    width: 25,
    height: 25,
    rx: 12.5,
    transform: "rotate(180 25 25.5)",
    fill: "#C53EAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 15.4215L10.3397 16.0589C10.3397 16.1141 10.4151 16.1447 10.466 16.1108L14.8795 13.2074C14.917 13.1828 14.9474 13.1514 14.9683 13.1154C14.9891 13.0795 15 13.04 15 13C15 12.96 14.9891 12.9205 14.9683 12.8846C14.9474 12.8486 14.917 12.8172 14.8795 12.7926L10.466 9.88915C10.4141 9.85534 10.3397 9.88585 10.3397 9.9411L9.99998 10.5785C9.99998 10.619 10.0225 10.6577 10.0597 10.6824L13.5843 12.9996L10.0597 15.3176C10.0225 15.3423 9.99999 15.3811 9.99999 15.4215Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkarrow);
export default __webpack_public_path__ + "static/media/pinkarrow.897d455d8ceb7f0726e04f83185b294a.svg";
export { ForwardRef as ReactComponent };